import Stepper, {StepperProps} from '@mui/material/Stepper';
import MobileStepper, {MobileStepperProps} from '@mui/material/MobileStepper';

import {styled} from '@mui/material/styles';

export const CStepper = styled(Stepper)<StepperProps>(
  (/* { theme } */) => ({
  }),
);

export const CMobileStepper = styled(MobileStepper)<MobileStepperProps>(
  (/* { theme } */) => ({
  }),
);
